export enum CountryGoalTypeEnum {
  Offers = 'offers',
  OffersValue = 'offersValue',
  OffersRehauValue = 'offersRehauValue',
  Registrations = 'registrations',
  InstallersActivation = 'installersActivation',
}
